import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

// Группа ссылок меню — отдельная навигация со своим названием (`aria-label` или
// `aria-labelledby` на `SidebarGroupLabel`).
export const SidebarGroup = ({ className, ...props }: ComponentProps<"nav">) => (
  <nav
    data-slot="sidebar-group"
    className={cn(
      "flex w-full flex-col gap-0.5 group-data-[state=collapsed]/sidebar:items-center",
      className,
    )}
    {...props}
  />
);
